// eslint-disable-next-line import/prefer-default-export
export { getBrandInfo } from './brandInfo';
